import { IssueCreatedAndResolvedTaskComparisonReportResult } from '@tap/data-providers';
import { PeriodSelectType, PeriodSelectTypeSpec, Widget } from '@tap/mui-ui';
import { ChartCustom, CustomChartTooltip } from '@tap/tap-ui';
import { dateTimeHelper } from '@tap/utils';
import {
    XAxis, YAxis, CartesianGrid,
    Tooltip as RechartsTooltip, Area, AreaChart, Legend,
} from 'recharts';

/* График "Созданные vs Завершённые заявки"
*/

// Динамически применяем стиль для разметки шкалы, в зависимости от количества знаков
const getStyleForYAxis = (maxValue: number) => {
    if (maxValue <= 99999999)
        return { fontSize: '12px' }
    else if (99999999 < maxValue && maxValue < 999999999)
        return { fontSize: '11px' }
    else
        return { fontSize: '10px' }
};

type CreatedAndResolvedTaskComparisonChartProps = {
    initialData: IssueCreatedAndResolvedTaskComparisonReportResult[],
    periodType: PeriodSelectType,
};

const getMaxValue = (initialData: IssueCreatedAndResolvedTaskComparisonReportResult[]) => {
    const createdTasksQuantityList = initialData?.map(item => item.createdCount);
    const completedTasksQuantityList = initialData?.map(item => item.completedCount);
    return Math.max(...createdTasksQuantityList) || Math.max(...completedTasksQuantityList) || 1;
};

const getCalculationData = (initialData: IssueCreatedAndResolvedTaskComparisonReportResult[]) => {
    return initialData.map((elem, index, arr) => {
        return {
            date: elem.date,
            completedCount: arr.slice(0, index + 1).reduce((a, b) => a += b.completedCount, 0),
            createdCount: arr.slice(0, index + 1).reduce((a, b) => a += b.createdCount, 0),
        }
    });
};


export default function CreatedAndResolvedTaskComparisonChart({ initialData, periodType }: CreatedAndResolvedTaskComparisonChartProps) {

    const calculationData = getCalculationData(initialData);
    const maxValue = getMaxValue(initialData);

    return (
        <Widget title={`График показывает количество созданных заявок относительно завершённых за последние ${PeriodSelectTypeSpec[periodType].daysQuantity} дней`}>
            <ChartCustom>
                <AreaChart data={calculationData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        dataKey="date"
                        scale="point"
                        tick={{ dy: 5, fontSize: '12px' }}
                        tickFormatter={(date: any) => dateTimeHelper.format(date, 'd MMM', true) || date}
                    />
                    <YAxis
                        domain={[1, maxValue]}
                        tick={getStyleForYAxis(maxValue)}
                    />
                    <RechartsTooltip
                        wrapperStyle={{ outline: 'none' }}
                        content={
                            <CustomChartTooltip
                                labelTemplate={() => ''}
                                valueTemplate={payload => {
                                    return (
                                        <>{payload.dataKey === 'completedCount' ? 'Завершено' : 'Создано'}: {payload.value}</>
                                    )
                                }}
                            />
                        }
                    />
                    <Legend />
                    <Area
                        isAnimationActive={false}
                        type="linear"
                        name={'Созданные заявки'}
                        dataKey="createdCount"
                        stroke={'#ee4444'}
                        fill={'rgb(250, 140, 140, 0.3)'}
                        fillOpacity="1"
                        dot={false}
                        strokeWidth={2}
                    />
                    <Area
                        isAnimationActive={false}
                        type="linear"
                        name={'Завершённые заявки'}
                        dataKey="completedCount"
                        stroke={'#039403'}
                        fill={'rgb(158, 245, 144, 0.3)'}
                        fillOpacity="1"
                        dot={false}
                        strokeWidth={2}
                    />
                </AreaChart>
            </ChartCustom>
        </Widget>
    );
}

